export function initLazyVideos() {
    const videos = document.querySelectorAll<HTMLVideoElement>('video[data-snippet-src]');
    if (!videos.length) return;
  
    if (!('IntersectionObserver' in window)) {
      videos.forEach((video) => {
        const src = video.getAttribute('data-snippet-src');
        if (!src) return;
        video.src = src;
        video.load();
        video.play().catch(() => {});
      });
      return;
    }
  
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          
          const video = entry.target as HTMLVideoElement;
          const src = video.getAttribute('data-snippet-src');
          if (!src) return;
  
          video.src = src;
          video.removeAttribute('data-snippet-src');
          video.load();
          video.play().catch(() => {});
          io.unobserve(video);
        });
      },
      { rootMargin: '100px 0px', threshold: 0.1 }
    );
  
    videos.forEach((video) => io.observe(video));
  }